import React, { useState, useEffect, useContext } from "react"
import PropTypes from "prop-types"
import { Box, Button, Typography } from "@mui/material"
import ContactCard from "components/Contacts/ContactCard"
import { PoppinsSemiBold } from "common/typographies"
import InviteUserModal from "./InviteUserModal"
import UserEditModal from "./UserEditModal"
import i18n from "i18n"

import AuthContext from "context/auth/authContext"
import * as amplitude from "@amplitude/analytics-browser"

const UserView = ({ user }) => {
  const [open, setOpen] = useState(false)

  const { freeTrialExpired, organizationUsers, organizationAdmin } =
    useContext(AuthContext)

  const [openEdit, setOpenEdit] = useState(false)

  const [Worker, setWorker] = useState(null)

  const showAddUser =
    !freeTrialExpired &&
    user["custom:role"] !== "WORKER" &&
    user["custom:subscription_plan"] &&
    ((user["custom_subscription_plan"] === "BASIC" &&
      organizationUsers.length < 4) ||
      ((user["custom:subscription_plan"] === "BUSINESS" ||
        user["custom:subscription_plan"] === "FREE_TRIAL") &&
        organizationUsers.length < 9) ||
      !["BASIC", "BUSINESS", "FREE_TRIAL"].includes(
        user["custom:subscription_plan"],
      ))

  useEffect(() => {
    if (openEdit == false) {
      setWorker(null)
    }
  }, [openEdit])

  useEffect(() => {
    amplitude.track("Gestion de equipo Visited")
  }, [])

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginLeft: "30px",
            marginRight: "30px",
            marginBottom: "25px",
          }}
        >
          <PoppinsSemiBold style={{ fontSize: "20px" }}>
            {i18n.t("Gestión de equipo")}
          </PoppinsSemiBold>
          {showAddUser && (
            <Button
              variant="contained"
              color="branded"
              onClick={() => setOpen(true)}
              sx={{ minWidth: 120, minHeight: 40, fontWeight: 600 }}
              data-testid="team-invite-add-user-button"
            >
              {i18n.t("Añadir Usuario")}
            </Button>
          )}
        </Box>
        <Box
          sx={{ flexGrow: 1 }}
          style={{
            marginLeft: "30px",
            marginTop: "20px",
            minHeight: "260px",
          }}
        >
          {/* <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <ContactCard
                contact={{
                  firstname: organizationAdmin["custom:nombre_apellido"]
                    ? organizationAdmin["custom:nombre_apellido"]
                    : organizationAdmin["email"]?.split("@")[0],
                  email: organizationAdmin["email"],
                  tags: [
                    {
                      tag_name: i18n.t("PROPIETARIO"),
                      tag_color: "#e0e0e0",
                    },
                  ],
                }}
              />
            </Grid>
            {organizationUsers &&
              organizationUsers.length > 0 &&
              organizationUsers.map((worker, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <div
                    onClick={() => {
                      setWorker(worker)
                      setOpenEdit(true)
                    }}
                    style={{ height: "100%" }}
                  >
                    <ContactCard
                      contact={{
                        firstname: worker.name,
                        email: worker.email,
                        tags:
                          worker.customRole && worker.customRole.value
                            ? [
                                {
                                  tag_name: worker.customRole.value,
                                  tag_color:
                                    worker.customRole.bgColor || undefined,
                                },
                              ]
                            : [],
                      }}
                    />
                  </div>
                </Grid>
              ))}
          </Grid> */}
          <Typography
            component="p"
            variant="body2"
            sx={{
              color: "text.secondary",
              textAlign: "center",
              mt: 2,
              px: 2,
            }}
          >
            Esta sección se encuentra en mantenimiento. Disculpe las molestias.
          </Typography>
          <Typography
            component="p"
            variant="body2"
            sx={{
              color: "text.secondary",
              textAlign: "center",
              mt: 2,
              px: 2,
            }}
          >
            Mientras tanto, se pueden seguir invitando usuarios, pero no es
            posible visualizar la lista de usuarios del equipo.
          </Typography>
        </Box>
      </Box>
      {open ? <InviteUserModal open={open} setOpen={setOpen} /> : null}

      {openEdit && (
        <UserEditModal open={openEdit} setOpen={setOpenEdit} worker={Worker} />
      )}
    </>
  )
}

UserView.propTypes = {
  user: PropTypes.object.isRequired,
}

export default UserView
